import React, { useState, useEffect } from 'react';
import { observer, inject } from "mobx-react"

import { Button, Grid, Typography, IconButton, LinearProgress/*, MenuItem, InputLabel*/ } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import DialogContent from '@mui/material/DialogContent';
import FormControlLabel from '@mui/material/FormControlLabel';
/*import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';*/
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';

import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import DeleteIcon from '@mui/icons-material/Delete';
import BurstModeIcon from '@mui/icons-material/BurstMode';


import CloseIcon from '@mui/icons-material/Close';

import getGoruntulemeCategoryList from '../../../utils/api/Doctor/Examination/GetGoruntulemeCategoryList'
import getGoruntulemeProductList from '../../../utils/api/Doctor/Examination/GetGoruntulemeProductList'
import postGoruntulemeTalep from '../../../utils/api/Doctor/Examination/PostGoruntulemeTalep'
/*
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};*/

export const GoruntulemeMenu = inject("store")(observer((props) => {

    const selectedFirmId = 1
    const [goruntuCategoryList, setGoruntuCategoryList] = useState([])
    const [goruntuProductList, setGoruntuProductList] = useState([])
    const [selectedProductList, setSelectedProductList] = useState([])
    const [isSended, setIsSended] = useState(false)
    const [selectedCategoryName, setSelectedCategoryName] = useState("")
    const [selectedCategoryColor, setSelectedCategoryColor] = useState("")

    const onClickCloseGoruntulemeDialogMenu = () => {
        props.store.setGoruntulemeDialogMenuDisplay(false)
    }

    useEffect(() => {
        // Update the document title using the browser API
        //console.log("props.images: ", props.images)
        if(props.images !== null){
            setIsSended(true)
            setSelectedProductList(props.images)
        }
        getGoruntulemeCategoryListReq()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.images]);

    const getGoruntulemeCategoryListReq = async () => {
        props.store.setLoadingBarStatus(false)
        let examinationListCategoryListResponse = await getGoruntulemeCategoryList(props.store.baseUrl,
            props.store.token, props.store.doctor[0].id, selectedFirmId)

        if (examinationListCategoryListResponse !== null && examinationListCategoryListResponse !== undefined) {
            if (examinationListCategoryListResponse.status === 200) {
                //console.log("examinationListCategoryListResponse: ", examinationListCategoryListResponse)
                setGoruntuCategoryList(examinationListCategoryListResponse.data)
            }
        }
        props.store.setLoadingBarStatus(true)
    }

    /*const onChangeGoruntulemeFirmListSelectMenu = async (event) => {
        props.store.setLoadingBarStatus(false)

        if (event.target.value !== selectedFirmId) {
            setSelectedProductList([])
        }

        setSelectedFirmId(1)

        let examinationListCategoryListResponse = await getGoruntulemeCategoryList(props.store.baseUrl,
            props.store.token, props.store.doctor[0].id, event.target.value)

        if (examinationListCategoryListResponse !== null && examinationListCategoryListResponse !== undefined) {
            if (examinationListCategoryListResponse.status === 200) {
                console.log("examinationListCategoryListResponse: ", examinationListCategoryListResponse)

                setState({
                    goruntuCategoryList: examinationListCategoryListResponse.data
                })
            }
        }
        props.store.setLoadingBarStatus(true)
    }*/

    const onClickGoruntulumeCategoryButton = async (categoryId) => {
        props.store.setLoadingBarStatus(false)

        let examinationProductListResponse = await getGoruntulemeProductList(props.store.baseUrl, props.store.token,
            props.store.doctor[0].id, selectedFirmId, categoryId)

        //console.log("examinationProductListResponse: ", examinationProductListResponse)
        if (examinationProductListResponse.data !== null) {
            for (let index = 0; index < goruntuCategoryList.length; index++) {
                const examinationCategory = goruntuCategoryList[index];
                if (examinationCategory.imageCategoryId === categoryId) {
                    setSelectedCategoryName(examinationCategory.categoryName)
                    setSelectedCategoryColor(examinationCategory.color)
                }
            }
            if (examinationProductListResponse !== null && examinationProductListResponse !== undefined) {
                if (examinationProductListResponse.status === 200) {
                    // console.log("examinationProductListResponse: ", examinationProductListResponse)
                    if (examinationProductListResponse.data !== null) {
                        setGoruntuProductList(examinationProductListResponse.data)
                    } else {
                        setGoruntuProductList([])
                    }
                }
            }
        } else {
            props.store.setMessage("Seçtiğiniz kategori için bir görüntüleme ürünü bulunamadı.", true, "error")
        }
        props.store.setLoadingBarStatus(true)
    }

    const checkProductSelectedAlready = (product) => {
        let productExist = false
        for (let i = 0; i < selectedProductList.length; i++) {
            const tempSelectedProduct = selectedProductList[i];
            if (tempSelectedProduct.imageId === product.imageId) {
                productExist = true
            }
        }
        return productExist;
    }

    const onClickSelectProduct = (product) => {
        let productExist = checkProductSelectedAlready(product)
        if (productExist) {
            setSelectedProductList(selectedProductList.filter(a =>
                a.imageId !== product.imageId
            ))
        } else {
            product.color = selectedCategoryColor
            product.categoryName = selectedCategoryName
            setSelectedProductList([...selectedProductList, product])
        }
    }

    const onClickDeleteSelectedProduct = (product) => {
        setSelectedProductList(selectedProductList.filter(a =>
            a.imageId !== product.imageId
        ))
    }

    const onClickSaveImageTalep = async () => {
        //console.log("examination: ", selectedProductList)
        let fixedImageListesi = []
        for (let index = 0; index < selectedProductList.length; index++) {
            const tempProduct = selectedProductList[index];
            let goruntuleme = {
                labImageId: tempProduct.imageId,
                patientId: props.patient.patientId,
                appointmentId: Number(props.appointmentId),
            }
            fixedImageListesi.push(goruntuleme)
        }

        let postExaminationListResponse = await postGoruntulemeTalep(props.store.baseUrl, props.store.token, props.store.doctor[0].id, props.appointmentId,
            fixedImageListesi)

        if (postExaminationListResponse !== null && postExaminationListResponse !== undefined) {
            if (postExaminationListResponse.status === 200) {
                setIsSended(true)
                props.store.setMessage("Tetkikler başarıyla gönderildi.", true, "success")
            } else {
                props.store.setMessage("Tetkikler gönderilirken hata oluştu.", true, "error")
            }
        } else {
            props.store.setMessage("Tetkikler gönderilirken hata oluştu.", true, "error")
        }
        //console.log("postExaminationListResponse: ", postExaminationListResponse)
        //console.log("fixedTetkikListesi: ", fixedImageListesi)
    }

    const onClickUpdateImageTalep = async () => {
        //console.log("examination: ", selectedProductList)
        let fixedImageListesi = []
        for (let index = 0; index < selectedProductList.length; index++) {
            const tempProduct = selectedProductList[index];
            let goruntuleme = {
                imageId: tempProduct.imageId,
                labImageId: tempProduct.imageId,
                patientId: props.patient.patientId,
                appointmentId: Number(props.appointmentId),
            }
            fixedImageListesi.push(goruntuleme)
        }

        let postExaminationListResponse = await postGoruntulemeTalep(props.store.baseUrl, props.store.token, props.store.doctor[0].id, props.appointmentId,
            fixedImageListesi)

        if (postExaminationListResponse !== null && postExaminationListResponse !== undefined) {
            if (postExaminationListResponse.status === 200) {
                setIsSended(true)
                props.store.setMessage("Tetkikler başarıyla gönderildi.", true, "success")
            } else {
                props.store.setMessage("Tetkikler gönderilirken hata oluştu.", true, "error")
            }
        } else {
            props.store.setMessage("Tetkikler gönderilirken hata oluştu.", true, "error")
        }
        /*console.log("postExaminationListResponse: ", postExaminationListResponse)
        console.log("fixedTetkikListesi: ", fixedImageListesi)*/
    }

    return (
        <>
            <Dialog fullScreen open={props.store.goruntulemeDialogMenuDisplay}>
                <AppBar sx={{ position: 'relative', background: "#2196f3" }}>
                    <Toolbar>
                        <IconButton onClick={onClickCloseGoruntulemeDialogMenu}
                            edge="start"
                            color="inherit"
                            aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            Görüntüleme Paneli
                        </Typography>
                        {
                            (isSended) ?
                                <Button color="info" variant='contained' onClick={onClickUpdateImageTalep}>
                                    GÖRÜNTÜLEME TALEBİNİ GÜNCELLE
                                </Button> :

                                <Button color="info" variant='contained' onClick={onClickSaveImageTalep}>
                                    GÖRÜNTÜLEME TALEBİNİ KAYDET</Button>
                        }
                    </Toolbar>
                    <div style={{ position: "absolute", height: "5px", width: "100%", zIndex: "5000" }}>
                        <LinearProgress style={{ display: (props.store.loadingBarStatus) ? "none" : "block" }} color="primary" />
                    </div>
                </AppBar>
                <DialogContent>
                    {
                        /*
                            <FormControl style={{ width: "250px" }}>
                                <InputLabel>Labaratuar Seçiniz</InputLabel>
                                <Select labelId="insurance-select-label"
                                    value={selectedFirmId} label="Labaratuar Seçiniz"
                                    id="insurance-select" style={{ background: "#fff" }}
                                    onChange={onChangeGoruntulemeFirmListSelectMenu} MenuProps={MenuProps}>
                                    {(props.examinationListFirm !== null) ? props.examinationListFirm.map((examinationFirm, idx) => (
                                        <MenuItem key={idx} value={examinationFirm.firmid}>{examinationFirm.firmName}</MenuItem>
                                    )) : null}
                                </Select>
                            </FormControl>
                        */
                    }

                    <Grid container spacing={0} style={{
                        width: "100%", marginTop: "15px", border: "1px solid #e0e0e0", height: "calc(100vh - 200px)",
                        maxHeight: "calc(100vh - 200px)", overflowY: "auto", borderRadius: "10px"
                    }}>
                        <Grid item xs={3} style={{
                            padding: "10px", borderRight: "1px solid #e0e0e0", height: "calc(100vh - 200px)",
                            maxHeight: "calc(100vh - 205px)"
                        }}>
                            <Typography variant='body2' style={{ fontWeight: "bold" }}>
                                Görüntüleme Kategori Listesi
                            </Typography>

                            <List sx={{
                                width: '100%',
                                bgcolor: 'background.paper',
                                position: 'relative',
                                overflow: 'auto',
                                maxHeight: 'calc(100vh - 250px)',
                                '& ul': { padding: 0 },
                            }}>
                                {
                                    goruntuCategoryList.map((category, idx) => (
                                        <ListItem key={idx} disablePadding>
                                            <ListItemButton onClick={() => onClickGoruntulumeCategoryButton(category.imageCategoryId)} >
                                                <ListItemAvatar>
                                                    <Avatar style={{ background: category.color }}>
                                                        <BurstModeIcon />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <ListItemText primary={category.categoryName} />
                                            </ListItemButton>
                                        </ListItem>
                                    ))
                                }
                            </List>
                        </Grid>
                        <Grid item xs={5} style={{
                            padding: "10px", borderRight: "1px solid #e0e0e0", overflowY: 'auto',
                            maxHeight: 'calc(100vh - 205px)',
                        }}>
                            <Typography variant='body2' style={{ fontWeight: "bold" }}>
                                Seçtiğinin Kategoriye Bağlı Görüntüleme Listesi
                            </Typography>
                            <FormGroup sx={{
                                width: '100%',
                                '& ul': { padding: 0 },
                            }}>
                                {
                                    (goruntuProductList.length !== 0) ?
                                        goruntuProductList.map((product, idx) => (
                                            <FormControlLabel key={idx} control={
                                                <Checkbox checked={checkProductSelectedAlready(product)}
                                                    onChange={() => onClickSelectProduct(product)} />}
                                                label={product.imageName} style={{ fontSize: "12px" }} />
                                        ))
                                        : <Typography variant='body2'>Henüz kategori seçmediniz ya da seçtiğiniz kategoride tanımlı tetkik bulunmamaktadır.</Typography>
                                }
                            </FormGroup>
                        </Grid>
                        <Grid item xs={4} style={{ padding: "10px", }}>
                            <Typography variant='body2' style={{ fontWeight: "bold" }}>
                                Seçilen Görüntüleme Listesi
                            </Typography>
                            {
                                selectedProductList.map((product, idx) => (
                                    <ListItem key={idx}
                                        secondaryAction={
                                            <IconButton edge="end" aria-label="delete" onClick={() => onClickDeleteSelectedProduct(product)}>
                                                <DeleteIcon />
                                            </IconButton>
                                        } >
                                        <ListItemAvatar>
                                            <Avatar style={{ background: product.color }}>
                                                <BurstModeIcon />
                                            </Avatar>
                                        </ListItemAvatar>
                                        <Typography style={{ paddingTop: "4px", paddingBottom: "4px", fontSize: "13px" }}>
                                            {(product.categoryName !== undefined) ? product.categoryName + " - " + product.imageName : product.imageName}
                                        </Typography>
                                    </ListItem>
                                ))
                            }
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </>
    )
}))